import { Price } from "./price.model"
import { CombinationSelectionItem } from "./combination-selection-item.model"
import { CombinationProduct } from "./combination-product.model"

import { CombinationAttendee } from "./combination-attendee.model"

export class Combination {
  public start: string;
  public end: string;
  public durationInSeconds: number;
  public price: Price;
  public selectionItems: CombinationSelectionItem[]; //think about renaming the field... table vs combinationSelectionItem...
  public products: CombinationProduct[];
  public attendees: CombinationAttendee[];

  public eventPreference: string; //0 cannot decide yet
  public regularOfferAvailable: boolean;

  public events: string[];


  setEventPreference( eventPreference ) {
    this.eventPreference = eventPreference;
  }

  setRegularOfferAvailable( regularOfferAvailable ) {
    this.regularOfferAvailable = regularOfferAvailable;
  }

  constructor(
    obj?: any 
  ) {
    this.start = obj && obj.start || null;
    this.end = obj && obj.end || null;
    this.durationInSeconds = obj && obj.durationInSeconds || null;

    this.eventPreference = obj && obj.eventPreference || null;
    this.regularOfferAvailable = obj && obj.regularOfferAvailable || null;

    this.events = obj && obj.events || null;

    if ( obj && obj.price ) {
      this.price = new Price( obj.price, obj.currency ? obj.currency : 'EUR' );
    }

    if ( obj && obj.selectionItems ) {

       this.selectionItems = [];

       for (let selectionItem of obj.selectionItems ) {

         if ( selectionItem instanceof CombinationSelectionItem ) {
           this.selectionItems.push( selectionItem );
         } else {
           this.selectionItems.push( new CombinationSelectionItem( selectionItem ) );
         }

       }

       //wonderland exception
       /*if ( this.eventPreference === '20957' && this.selectionItems.length > 0 ) {
         this.selectionItems.length = 1;
         this.selectionItems[0].locationHref = 'https://api.pricepilot.io/providers/437/services/20831/selectionitems/4227';
       }

       if ( this.eventPreference === '21199' && this.selectionItems.length > 0 ) {
         this.selectionItems.length = 1;
         this.selectionItems[0].locationHref = 'https://api.pricepilot.io/providers/437/services/20831/selectionitems/4240';
       }*/

    }

    if ( obj && obj.products ) {
       this.products = [];

       for (let selectionItem of obj.selectionItems ) {

         if ( selectionItem instanceof CombinationSelectionItem ) {
           this.selectionItems.push( selectionItem );
         } else {
           this.selectionItems.push( new CombinationSelectionItem( selectionItem ) );
         }

       }
       
    }
    
  }
}
